<template>
  <div
    id="login-nav-menu-wrapper"
    ref="loginNavMenu"
    class="login-nav"
    @keydown.tab="accessibilityHandler"
  >
    <div
      v-if="isOpen"
      class="login-nav__wrapper"
    >
      <div
        id="list-items"
        class="login-nav__list-items"
      >
        <div class="login-nav__item login-nav__item--close">
          <button
            id="close-button"
            ref="closeBtn"
            type="button"
            class="login-nav__item--close__button"
            @click="$emit('loginNavClose', true)"
            @keydown.enter.prevent="$emit('loginNavClose', true)"
          >
            <span class="sr-only">
              {{ closeA11yLabel }}
            </span>
          </button>
        </div>
        <p
          v-if="isConnected"
          :data-cs-mask="containsUserName"
          class="login-nav__item login-nav__item--title"
        >
          {{ containsUserName ? statusInfo.username : item.text }}
        </p>
        <LoyaltyCard
          v-if="(isConnected && !isMember) || !isConnected && itemLoyaltyCard"
          :loyalty-card-text="itemLoyaltyCard.text"
          :loyalty-card-title="itemLoyaltyCard.title"
          :is-connected="isConnected"
        >
          <button
            v-if="joinItem"
            class="login-nav__item-button login-nav__item--round__button--round-principcal login-nav__item--round__button"
            type="button"
            @click.prevent="executeItemActionAndRedirection(joinItem)"
            @keydown.enter="executeItemActionAndRedirection(joinItem)"
          >
            {{ joinItem.text }}
          </button>
        </LoyaltyCard>
        <StatusPointsCard
          v-if="isConnected && isMember && statusInfo && StatusPointWording"
          :wordings="StatusPointWording"
          :status-info="statusInfo"
          :lang="lang"
        />
        <ul class="login-nav__list-items">
          <li
            v-for="item in itemListCta"
            :key="item.key"
            class="login-nav__item login-nav__item-cta"
            :class="itemListCta.length === 1 ? 'login-nav__item-cta_onerow' : ''"
          >
            <button
              class="login-nav__item-button"
              :class="item.key === 'signin' ? 'login-nav__item-button--round-sec login-nav__item--round__button__clear' : 'login-nav__item--round__button--round-principcal login-nav__item--round__button'"
              type="button"
              @click.prevent="executeItemActionAndRedirection(item)"
              @keydown.enter="executeItemActionAndRedirection(item)"
            >
              {{ item.text }}
            </button>
          </li>
          <li
            v-for="(item, index) in itemListLinks"
            :key="index"
            class="login-nav__item login-nav__item--button__classic"
            :class="[item.separated && item.separated !== '' ? 'login-nav__item--button__separated__'+item.separated : '', item.key === 'status' ? 'login-nav__item login-nav__item--status' : '']"
          >
            <component
              :is="item.key === 'logout' ? 'button' : 'a'"
              :type="item.key === 'logout' ? 'button' : null"
              class="login-nav__item--link"
              :class="item.highlight ? 'login-nav__item--highlight' : ''"
              :href="item.link"
              @click.prevent="executeItemActionAndRedirection(item)"
              @keydown.enter="executeItemActionAndRedirection(item)"
            >
              {{ item.text }}
            </component>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="es" src="./Menu.es"></script>
<style lang="scss" src='./Menu.scss' scoped></style>
